<template>
    <modal-wrapper modalClass="modal--small" :modalName="name">
        <div class="modal__header">
            <h1>Styleguide modal small</h1>
        </div>
        <div class="modal__content">
            Modal for for example a confirmation or simple question.
        </div>
        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--save pull-right" type="submit">Ok</button>
                <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">Cancel</button>
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import ModalWrapper from '@/components/general/ModalWrapper';

    @Component
    export default class StyleguideModalSmall extends Vue {
        name = 'styleguide-modal-small';
    }

    Vue.component('styleguide-modal-small', StyleguideModalSmall);
</script>



// WEBPACK FOOTER //
// src/components/modals/styleguide/StyleguideModalSmall.vue